export const HcpDcrSectionFields = {
	Name: [
		'firstNameCda_V',
		'middleNameCda_V',
		'lastNameCda_V',
		'prefixCda_V',
		'suffixCda_V'
	],

	Professional: [
		'hcpTypeLocal_VId',
		'hcpType',
		'degrees',
		'hcpSpecialties',
		'allSpecLocal_VId',
		'prescriberCda_V',
		'inCurrentPecos_V',
		'telehealth_V',
		'statusCda_V'
	],

	IDs: ['nhidCda_V', 'nhid2_V'],

	Demographics: [
		'languageCda_V',
		'gender_V',
		'birthYear_V',
		'dataPrivacyOptOut_V',
		'gradSchool_V',
		'gradYear_V'
	],

	Contact: [
		'officePhoneCda_V',
		'faxCda_V',
		'emailCda_V',
		'email2_V',
		'email3_V',
		'email4_V',
		'email5_V',
		'phone2_V',
		'websiteCda_V'
	],

	Addresses: ['addresses'],

	Licenses: ['licenses'],

	Affiliations: ['parenthcos']
};
